import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Route, withRouter } from 'react-router-dom';
import compose from 'recompose/compose';
import { ThemeProvider } from '@carvana/showroom-theme';
import { withDocumentTitle } from '@carvana/purchase-helpers';
import './ducks/reducer';

const ContentWrapper = styled.div`
  padding-bottom: 90px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VehicleConfirmation = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-confirmation" */ './components/confirmation'
  )
);

const VehicleMissing = lazy(() =>
  import(/* webpackChunkName: "vehicle-missing" */ './components/missing')
);

const VehicleSoldOnLot = lazy(() =>
  import(/* webpackChunkName: "vehicle-missing" */ './components/sold-on-lot')
);

const VehicleUnavailable = lazy(() =>
  import(
    /* webpackChunkName: "vehicle-unavailable" */ './components/unavailable'
  )
);

const Routes = props => {
  const {
    match: { path }
  } = props;

  return (
    <ThemeProvider>
      <Route
        exact
        path={`${path}/confirmation`}
        render={() => (
          <ContentWrapper>
            <VehicleConfirmation {...props} />
          </ContentWrapper>
        )}
      />

      <Route
        exact
        path={`${path}/missing`}
        render={() => (
          <ContentWrapper>
            <VehicleMissing {...props} />
          </ContentWrapper>
        )}
      />

      <Route
        exact
        path={`${path}/sold-on-lot`}
        render={() => (
          <ContentWrapper>
            <VehicleSoldOnLot {...props} />
          </ContentWrapper>
        )}
      />

      <Route
        exact
        path={`${path}/unavailable`}
        render={() => (
          <ContentWrapper>
            <VehicleUnavailable {...props} />
          </ContentWrapper>
        )}
      />

      <Route exact path={path} render={() => null} />
    </ThemeProvider>
  );
};

Routes.propTypes = {
  match: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool
};

Routes.defaultProps = {
  isLoading: false
};

export default compose(
  withDocumentTitle('Vehicle'),
  withRouter
)(Routes);
